"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const statusType_1 = require("./statusType");
const statics_1 = require("./statics");
/*
    A unified result class for moving app status messages across in the program flow
*/
class Result {
    constructor() {
        this.Id = (0, statics_1.newGuid)();
        this.status = statusType_1.StatusType.FAILED;
        this.messages = [];
        this.returnValue = null;
    }
    setValue(value) {
        this.returnValue = value;
    }
    getValue() {
        return this.returnValue;
    }
    log(message) {
        this.messages.push(message);
    }
    setStatus(status) {
        this.status = status;
    }
    isOk() {
        return this.status === statusType_1.StatusType.OK;
    }
    getMessages() {
        return this.messages;
    }
    print() {
        console.log("RESULT LOG");
        this.messages.forEach(m => {
            console.log(m);
        });
        console.log("--");
    }
}
exports.default = Result;
